/* eslint-disable camelcase */
import React, { Component } from 'react';
import { Row, Col, Panel } from 'react-bootstrap';
import IncentivePerformance from './incentive-performance';

import './style.css';
import expand from '../../../assets/img/performances/Expand@2x.png';
import collapse from '../../../assets/img/performances/Collapse@2x.png';

class SellItPerformance extends Component {
  state = {
    open: false
  };

  toggleContent = () => {
    this.setState({ open: !this.state.open });
  };

  componentDidMount() {
    const { current_user } = this.props;
    if (current_user.attributes['user-group'] === 'staff') {
      this.setState({open: true});
    }
  }

  render() {
    const {
      correct_to_date, customer_number, name, incentives, outlet, current_user
    } = this.props;

    const { open } = this.state;

    let date = correct_to_date.split('/');
    date = `${date[1]}/${date[0]}/${date[2]}`;

    return (
      <div>
        <div className="incentive-performances">
          <Panel
            className={open ? 'panel-open' : 'panel-closed'}
            header={(
              <div onClick={this.toggleContent}>
                <Row>
                  <Col lg={10}>
                    {`${name}`} {customer_number}
                  </Col>
                  <Col lg={2}>
                    <img className="panel-toggle" src={open ? collapse : expand} />
                  </Col>
                </Row>
              </div>
            )}
          >
            {this.state.open && incentives.map((incentive, key) => (
              <IncentivePerformance
                key={key}
                outlet={outlet}
                incentive={incentive}
                correct_to_date={date}
                current_user={current_user}
              />
              ))
            }
          </Panel>
        </div>
      </div>
    );
  }
}

export default SellItPerformance;



// WEBPACK FOOTER //
// ./src/components/store-performance/sell-it/sell-it-performance.jsx